/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
  TelegramNotificationsPublicControllerUnsubscribeByLinkQueryParams,
} from '../../types/TelegramNotificationsPublicControllerUnsubscribeByLink.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramNotificationsPublicUnsubscribeByLink } from '../../methods/telegramNotificationsPublicUnsubscribeByLink.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramNotificationsPublicUnsubscribeByLinkQueryKey = (
  params: TelegramNotificationsPublicControllerUnsubscribeByLinkQueryParams,
) => [{ url: '/api/telegram/notifications/unsubscribe' }, ...(params ? [params] : [])] as const;

export type TelegramNotificationsPublicUnsubscribeByLinkQueryKey = ReturnType<
  typeof telegramNotificationsPublicUnsubscribeByLinkQueryKey
>;

export function telegramNotificationsPublicUnsubscribeByLinkQueryOptions(
  params: TelegramNotificationsPublicControllerUnsubscribeByLinkQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramNotificationsPublicUnsubscribeByLinkQueryKey(params);
  return queryOptions<
    TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramNotificationsPublicUnsubscribeByLink(params, config);
    },
  });
}

/**
 * {@link /api/telegram/notifications/unsubscribe}
 */
export function useTelegramNotificationsPublicUnsubscribeByLink<
  TData = TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
  TQueryData = TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
  TQueryKey extends QueryKey = TelegramNotificationsPublicUnsubscribeByLinkQueryKey,
>(
  params: TelegramNotificationsPublicControllerUnsubscribeByLinkQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramNotificationsPublicControllerUnsubscribeByLinkQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramNotificationsPublicUnsubscribeByLinkQueryKey(params);

  const query = useQuery(
    {
      ...telegramNotificationsPublicUnsubscribeByLinkQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
